import { makeStyles } from '@material-ui/core/styles';

const styles = theme => ({
  formContainer:{
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    width: '70%',
    marginTop: 30
  },
  formField:{
    margin: '15px auto'
  },
  input:{
    fontSize: '1em',
    textAlign: 'center'
  },
  leftBoard:{
    height: 'calc(100% - 2px)',
    borderLeft: 'none',
    borderRadius: '0 4px 4px 0'
  },
  rightBoard:{
    height: 'calc(100% - 2px)',
    borderRight: 'none',
    borderRadius: '4px 0 0 4px'
  },
  middleBoard:{
    height: 'calc(100% - 2px)',
    borderLeft: 'none',
    borderRight: 'none',
    borderRadius: 0
  },
  withDivider: {
    position: 'relative',
    '&:after':{
      backgroundColor: '#d2d2d2',
      bottom: 0,
      content: "' '",
      position: 'absolute',
      top: 5,
      right: 0,
      width: 1,
      height: '40%',
      margin: 'auto'
    }
  },
})

export default makeStyles(styles)
